// export const API_BASE_URL = 'http://localhost:8000/';
// export const API_BASE_URL = 'https://mediumblue-wolverine-938980.hostingersite.com/';
// export const API_BASE_URL = 'https://mediumblue-wolverine-938980.hostingersite.com/';



// Local Backend URL
// export const API_BASE_URL= 'http://localhost:8000/';

// Lite Grocer Backend URL
export const API_BASE_URL= 'https://service.litegrocer.lk/';

// Testing Backend URL
// export const API_BASE_URL = 'https://navajowhite-newt-293708.hostingersite.com/';


export const API_URLS = {
  LOGIN: 'api/login',
  LOGOUT: 'api/logout',
  USERS: 'api/users',
  USER_BY_ID: (id) => `api/users/${id}`,
  USER_STATUS: (id) => `api/users/${id}/status`,
  REGISTER: 'api/register',
  PERMISSIONS: 'api/get-all-permissions',
  ROLES: 'api/get-all-roles',

  CATEGORIES: 'api/categories',
  CATEGORY_BY_ID: (id) => `api/categories/${id}`,
  CATEGORY_STATUS: (id) => `api/categories/${id}/status`,

  SUBCATEGORIES: 'api/sub-categories',
  SUBCATEGORY_BY_ID: (id) => `api/sub-categories/${id}`,
  SUBCATEGORY_STATUS: (id) => `api/sub-categories/${id}/status`,

  PRODUCTS: 'api/products',
  PRODUCT_BY_ID: (id) => `api/products/${id}`,
  PRODUCT_STATUS: (id) => `api/products/${id}/status`,
  PRODUCT_UPDATE_QUANTITY: (id) => `api/products/${id}/update-quantity`,

  GENERATE_BARCODES: 'api/barcodes/generate',
  PRODUCT_BARCODES: (productId) => `api/barcodes/product/${productId}`,

  EMPLOYERS: 'api/employers',
  EMPLOYER_BY_ID: (id) => `api/employers/${id}`,
  EMPLOYER_STATS: (id) => `api/employers/${id}/stats`,

  ORDERS: 'api/admin/orders',
  ORDER_BY_ID: (id) => `api/admin/orders/${id}`,
  ORDER_EDIT: (id) => `api/admin/orders/${id}/edit`,
  ORDER_STATUS: (id) => `api/admin/orders/${id}/status`,

  // User Log endpoints
  USER_LOGS: 'api/user-logs',
  USER_LOG_BY_ID: (id) => `api/user-logs/${id}`,
  USER_LOG_STATS: 'api/user-logs-stats',


  // E-commerce order URLs
  ECOMMERCE_ORDERS: 'api/ecommerce/orders',
  ECOMMERCE_ORDER_BY_ID: (id) => `api/ecommerce/orders/${id}`,
  ECOMMERCE_ORDER_EDIT: (id) => `api/ecommerce/orders/${id}`,
  ECOMMERCE_ORDER_STATUS: (id) => `api/ecommerce/orders/${id}/status`,
  ECOMMERCE_ORDER_ASSIGN_DRIVER: (id) => `api/ecommerce/orders/${id}/assign-driver`,
  ECOMMERCE_ORDER_ASSIGN_CASHIER: (id) => `api/ecommerce/orders/${id}/assign-cashier`,


  // Supplier endpoints
  SUPPLIERS: 'api/suppliers',
  SUPPLIER_BY_ID: (id) => `api/suppliers/${id}`,
  ACTIVE_SUPPLIERS: 'api/active-suppliers',

  // Supplier Payment endpoints
  SUPPLIER_PAYMENTS: 'api/supplier-payments',
  SUPPLIER_PAYMENT_BY_ID: (id) => `api/supplier-payments/${id}`,
  SUPPLIER_PAYMENTS_BY_SUPPLIER: (supplierId) => `api/suppliers/${supplierId}/payments`,
  SUPPLIER_PURCHASE_ORDERS_FOR_PAYMENT: (supplierId) => `api/suppliers/${supplierId}/purchase-orders-for-payment`,
  PURCHASE_ORDER_PAYMENT_SUMMARY: (purchaseOrderId) => `api/purchase-orders/${purchaseOrderId}/payment-summary`,
  SUPPLIER_PAYMENT_SUMMARY: (supplierId) => `api/suppliers/${supplierId}/payment-summary`,
  COMPLETED_PAYMENTS: 'api/completed-payments',

  // Purchase Order endpoints
  PURCHASE_ORDERS: 'api/purchase-orders',
  PURCHASE_ORDER_BY_ID: (id) => `api/purchase-orders/${id}`,
  PURCHASE_ORDER_MARK_ORDERED: (id) => `api/purchase-orders/${id}/mark-ordered`,
  PURCHASE_ORDER_MARK_DELIVERED: (id) => `api/purchase-orders/${id}/mark-delivered`,
  SUPPLIER_PURCHASE_ORDERS: (supplierId) => `api/suppliers/${supplierId}/purchase-orders`,
  PURCHASE_ORDER_UPDATE_DELIVERY: (id) => `api/purchase-orders/${id}/update-delivery`,
  DRAFT_PURCHASE_ORDERS: 'api/draft-purchase-orders',

  // Purchase Order Item endpoints
  PURCHASE_ORDER_ITEMS: 'api/purchase-order-items',
  PURCHASE_ORDER_ITEM_BY_ID: (id) => `api/purchase-order-items/${id}`,
  PURCHASE_ORDER_ITEM_MARK_RECEIVED: (id) => `api/purchase-order-items/${id}/mark-received`,

  // Product endpoints
  ACTIVE_PRODUCTS: 'api/active-products',

  SUPPLIER_PENDING_PAYMENTS_REPORT: 'api/supplier-payments/pending-report',
  SUPPLIER_PENDING_PAYMENTS: (supplierId) => `api/suppliers/${supplierId}/pending-payments`,


};

export const NAV_MENU_ITEMS = [
  {
    id: 1,
    name: 'Super Admin Dashboard',
    slug: 'super-admin-dashboard',
    permission: 1,
    icon: '🏠'
  },
  {
    id: 2,
    name: 'Admin Dashboard',
    slug: 'admin-dashboard',
    permission: 2,
    icon: '📊'
  },
  {
    id: 3,
    name: 'Product Management',
    slug: 'product-management',
    permission: 3,
    icon: '📦',
    submenus: [
      { id: 31, name: 'All Products', slug: 'all-products', permission: 3 },
      { id: 33, name: 'Categories', slug: 'categories', permission: 3 },
      { id: 34, name: 'Sub Categories', slug: 'sub-categories', permission: 3 }
    ]
  },
  {
    id: 4,
    name: 'Product QR Management',
    slug: 'product-qr-management',
    permission: 4,
    icon: '🔲',
    submenus: [
      { id: 41, name: 'Generate QR', slug: 'generate-qr', permission: 4 },
    ]
  },
  {
    id: 5,
    name: 'Sales',
    slug: 'sales',
    permission: 5,
    icon: '💰',
    submenus: [
      { id: 51, name: 'Cashier Order', slug: 'orders', permission: 5 },
      { id: 52, name: 'Web Orders', slug: 'WebOrders', permission: 5 },
      { id: 53, name: 'All Orders', slug: 'AllOrders', permission: 5 }
    ]
  },
  {
    id: 6,
    name: 'User Management',
    slug: 'user-management',
    permission: 6,
    icon: '👥',
    submenus: [
      { id: 61, name: 'All Users', slug: 'all-users', permission: 6 },
    ]
  },
  {
    id: 7,
    name: 'Suppliers',
    slug: 'suppliers',
    permission: 7,
    icon: '🏢',
    submenus: [
      { id: 79, name: 'Suppliers', slug: 'suppliers', permission: 7 },
      { id: 77, name: 'Purchase Orders', slug: 'purchase-orders', permission: 7 },
      { id: 78, name: 'Supplier Payments', slug: 'supplier-payments', permission: 7 },
      // { id: 78, name: 'Supplier Outstanding Payments', slug: 'supplier-outstanding-payments', permission: 7 },
    ]

  },
  {
    id: 8,
    name: 'Customers',
    slug: 'customers',
    permission: 8,
    icon: '👨‍💼'
  },
  {
    id: 9,
    name: 'Setting',
    slug: 'setting',
    permission: 9,
    icon: '⚙️'
  },
  {
    id: 10,
    name: 'Reports',
    slug: 'reports',
    permission: 10,
    icon: '📈',
    submenus: [
      { id: 101, name: 'Report', slug: 'reports', permission: 10 },
      { id: 102, name: 'All Report', slug: 'all-reports', permission: 10 },
      { id: 102, name: 'sales Report', slug: 'sales-reports', permission: 10 },
      { id: 102, name: 'inventory Report', slug: 'inventory-reports', permission: 10 },
      { id: 102, name: 'financial Report', slug: 'financial-reports', permission: 10 },
      // { id: 102, name: 'customer Report', slug: 'customer-reports', permission: 10 },
      { id: 102, name: 'ecommerce Report', slug: 'ecommerce-reports', permission: 10 },
      // { id: 106, name: 'Supplier Pending Payments', slug: 'supplier-Pending-payments-reports', permission: 10 },
      // { id: 102, name: 'product Report', slug: 'product-reports', permission: 10 },
    ]
  },
  {
    id: 11,
    name: 'Employer Management',
    slug: 'employer-management',
    permission: 11,
    icon: '👨‍💼'
  },
  {
    id: 12,
    name: 'User Log',
    slug: 'user-log',
    permission: 12,
    icon: '📋'
  }
];
